// Google OAuth Configuration
export const GOOGLE_CLIENT_ID = process.env.REACT_APP_GOOGLE_CLIENT_ID || 'YOUR_GOOGLE_CLIENT_ID_HERE';

export const GOOGLE_AUTH_CONFIG = {
  client_id: GOOGLE_CLIENT_ID,
  callback: handleCredentialResponse,
  auto_select: false,
  cancel_on_tap_outside: true,
};

// Handle the credential response from Google
function handleCredentialResponse(response) {
  console.log('Google credential response:', response);
  return response;
}

// Load Google Identity Services script
export const loadGoogleScript = () => {
  return new Promise((resolve, reject) => {
    if (window.google && window.google.accounts) {
      resolve();
      return;
    }

    const script = document.createElement('script');
    script.src = 'https://accounts.google.com/gsi/client';
    script.onload = resolve;
    script.onerror = reject;
    document.head.appendChild(script);
  });
};

// Initialize Google Identity Services
export const initializeGoogleAuth = async () => {
  try {
    await loadGoogleScript();
    
    if (window.google && window.google.accounts) {
      window.google.accounts.id.initialize({
        client_id: GOOGLE_CLIENT_ID,
        callback: handleCredentialResponse,
        auto_select: false,
        cancel_on_tap_outside: true,
      });
      
      return true;
    }
    
    throw new Error('Google Identity Services not loaded');
  } catch (error) {
    console.error('Failed to initialize Google Auth:', error);
    return false;
  }
};

// Render Google Sign In button
export const renderGoogleButton = (element, config = {}) => {
  if (!window.google || !window.google.accounts) {
    console.error('Google Identity Services not loaded');
    return;
  }

  const defaultConfig = {
    type: 'standard',
    theme: 'outline',
    size: 'large',
    text: 'signin_with',
    shape: 'rectangular',
    logo_alignment: 'left',
    width: '100%',
    ...config
  };

  window.google.accounts.id.renderButton(element, defaultConfig);
};

// Prompt for Google Sign In
export const promptGoogleSignIn = () => {
  if (!window.google || !window.google.accounts) {
    console.error('Google Identity Services not loaded');
    return;
  }

  window.google.accounts.id.prompt();
};